module.exports = __webpack_public_path__ + "img/base_divers_allumer_eteindre.2facdb09.svg";